import React from "react"
import { Button, Container, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import shop from "shop/shop"

const defaultVisible = sessionStorage.getItem( "top-notification" )

export default function TopNotification( { text = "Neu im Onlineshop", cta = "Jetzt ansehen", to = "/" } ) {
  if ( !shop.config.topNotification ) return null
  if ( !shop.session ) return null
  if (shop.session && shop.session.shopuser && shop.session.shopuser.guest && shop.session.shopuser.guest == true) return null
  const [visible, setVisible] = React.useState( defaultVisible === "0" ? false : true )
  if ( !visible ) return null
  return <div className={"TopNotification bg-black white animate fadeInDown"}>
    <div className="pv3">
      <Container>
        <div className="f5 flex flex-row items-center justify-between">
          <div className="b">{shop.config.topNotification.text}</div>
          <div>
            <Button primary size="small" as={Link} to={shop.config.topNotification.to}>{translate( shop.config.topNotification.cta )}</Button>
            <Button icon={"times"} inverted onClick={() => {
              sessionStorage.setItem( "top-notification", 0 )
              setVisible( false )
              document.location.reload()
            }}/>
          </div>
        </div>
      </Container>
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/components/Segment/TopNotification.js